import axios from 'axios';

import querystring from 'querystring';

export default {
  namespaced: true,
  state: {
  },
  getters: {
  },
  mutations: {
  },
  actions: {
    async retrieveAllProjects(context, data = {}) {
      try {
        const config = { withCredentials: true };
        if (data && data.sharedToken) config.headers = { Authorization: data.sharedToken };
        const projects = await axios.get(`/autodesk/bim-360/account-admin/projects?${data.query ? querystring.stringify(data.query) : ''}`, config);
        return projects.data;
      } catch (error) {
        throw error;
      }
    },
    async retrieveProjectById(context, data) {
      try {
        const config = { withCredentials: true };
        if (data && data.sharedToken) config.headers = { Authorization: data.sharedToken };
        const project = await axios.get(`/autodesk/bim-360/account-admin/projects/${data.id}`, config);
        return project.data;
      } catch (error) {
        throw error;
      }
    },
    async updateProjectById(context, data) {
      try {
        const config = { withCredentials: true };
        if (data && data.sharedToken) config.headers = { Authorization: data.sharedToken };
        const project = await axios.patch(`/autodesk/bim-360/account-admin/projects/${data.projectId}`, data.project, config);
        return project.data;
      } catch (error) {
        throw error;
      }
    },
  },
};
